import React, { useCallback, useEffect, useState } from "react";
import { API_BASE } from "../apiConfig";
import "./InAppCommunicationLayer.css";

export default function InAppCommunicationLayer() {
  const [current, setCurrent] = useState(null);

  const poll = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/reminders/in-app`, { credentials: "include" });
      if (!res.ok) return;
      const data = await res.json().catch(() => ({}));
      const list = Array.isArray(data?.messages) ? data.messages : [];
      if (!list.length) {
        setCurrent(null);
        return;
      }
      const first = list[0];
      setCurrent((c) => {
        if (c && c.id === first.id) return c;
        return first;
      });
    } catch {
      /* offline */
    }
  }, []);

  useEffect(() => {
    void poll();
    const t = setInterval(() => void poll(), 52000);
    return () => clearInterval(t);
  }, [poll]);

  const dismiss = async () => {
    if (!current?.id) return;
    try {
      await fetch(`${API_BASE}/api/reminders/in-app/consume`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: current.id }),
      });
    } catch {
      /* ignore */
    }
    setCurrent(null);
    void poll();
  };

  if (!current) return null;

  const rtl = current.lang === "he";
  const ok =
    current.lang === "he" ? "הבנתי" : current.lang === "es" ? "Entendido" : "OK";

  return (
    <div className="inapp-comm-overlay" dir={rtl ? "rtl" : "ltr"}>
      <div className="inapp-comm-card" role="dialog" aria-modal="true" aria-labelledby="inapp-comm-h">
        <h3 id="inapp-comm-h" className="inapp-comm-title">
          {current.title}
        </h3>
        <p className="inapp-comm-body">{current.body}</p>
        <button type="button" className="inapp-comm-ok" onClick={dismiss}>
          {ok}
        </button>
      </div>
    </div>
  );
}
